var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalkbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1796 11.8397H15.1987M24.7489 11.8397H24.768M31.4474 2.27045C32.9701 2.27045 34.4305 2.87536 35.5073 3.95212C36.5841 5.02887 37.189 6.48926 37.189 8.01202V23.3229C37.189 24.8457 36.5841 26.3061 35.5073 27.3828C34.4305 28.4596 32.9701 29.0645 31.4474 29.0645H21.8781L12.3088 34.806V29.0645H8.48108C6.95832 29.0645 5.49793 28.4596 4.42117 27.3828C3.34442 26.3061 2.7395 24.8457 2.7395 23.3229V8.01202C2.7395 6.48926 3.34442 5.02887 4.42117 3.95212C5.49793 2.87536 6.95832 2.27045 8.48108 2.27045H31.4474Z",
    stroke: "#922731",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1796 19.4952C15.8033 20.1317 16.5477 20.6374 17.3693 20.9827C18.1908 21.3279 19.073 21.5057 19.9642 21.5057C20.8554 21.5057 21.7376 21.3279 22.5592 20.9827C23.3807 20.6374 24.1252 20.1317 24.7489 19.4952",
    stroke: "#922731",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkbot);
export default __webpack_public_path__ + "static/media/Talkbot.1fa0a1e4c9d9878a3ec071f7ecbb1b1c.svg";
export { ForwardRef as ReactComponent };